import { Component, OnInit, Input, Output, EventEmitter, Injectable, ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment';

declare var $: any;
@Component({
  selector: 'app-contenant',
  templateUrl: './contenant.component.html',
  styleUrls: ['./contenant.component.css']
})
export class ContenantComponent implements OnInit {
  @Input() item;
  @Input() common;
  @Input() champQte;
  @Input() showNotif;
  @Input() showIconAdd;
  @Input() showcht;
  @Input() showCode;
  @Input() showQte;
  @Input() hide_hovergrp;
  @Input() addClassGroupCreate;
  @Input() isEditableTypeContenant: Boolean = false;
  @Input() showAllArticle: Boolean = false;
  @Input() showPopOver: Boolean = false;
  @Input() activatePopOver: Boolean = false;
  @Input() showVoirFiche: Boolean = false;
  @Input() pasDetailGroupe: Boolean = false;
  @Input() hide_contrat: Boolean = false;
  @Input() isListetourne;
  @Output() close = new EventEmitter<any>();
  infobulle: any;
  listQte = [];
  typeContenant = [];
  qteSelected: any = {};
  placementPopoverInfo = 'right';
  listeBenne6 = [];
  private foo: any = null;
  societe: any = {};
  periodeLocation = [
    { id: 1, libelleObjetEntite: 'Mensuelle' },
    { id: 2, libelleObjetEntite: 'Trimestrielle' },
    { id: 3, libelleObjetEntite: 'Semestrielle' },
    { id: 4, libelleObjetEntite: 'Annuelle' },
  ];

  typeFacturation = [
    { id: 0, libelleObjetEntite: 'Au mois' },
    { id: 1, libelleObjetEntite: 'A la journée' },
  ];

  isClickVoirplus: Boolean = false;

  constructor() {

  }

  chargeValue() {
    let fact = Object.assign({}, this.item);
    fact['typeLocation'] = fact['typeLocation'] || 1;
    this.periodeLocation.forEach(elt => {
      if (elt.id === parseInt(fact['typeLocation'], 10)) {
        this.item['periodeLoc'] = elt;
      }
    })
    fact['isLocImmediat'] = fact['isLocImmediat'] || false;
    
  }

  ngOnInit() {
    this.infobulle = {};
    this.listQteCombo();
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.searchTypecontenantByLibelle('');
    this.typeContenant = this.typeContenant || [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.typeContenant.forEach(elt => {
      if (this.item.typeContenant && elt.id === this.item.typeContenant.id) {
        this.item.typeContenant.libelleObjetEntite = elt.libelleObjetEntite;
      }
    })
    this.qteSelected = {
      id: this.item.qteContenant,
      libelleObjetEntite: this.item.qteContenant
    };
    this.listeBenne6 = [];
    if (this.item && this.item.isGroupeBenne && this.item.listBennes) {
      this.item.listBennes.forEach((element, index) => {
        if (index < 6) {
          this.listeBenne6.push(element)
        }
      });
    }

    if (this.item) {
      this.item.listBon = (this.item.listBon || []).sort((a, b) => moment(a.date, 'DD/MM/YYYY').diff(moment(b.date, 'DD/MM/YYYY')));
    }
    this.chargeValue()
  }
  mouseEnterNotassign($event, item, id) {
    item.showPopover = false;
  }

  onMouseOver($event, item) {
    // if (!item.isGroupeBenne) {
      this.placementPopoverInfo = 'right'
      this.infobulle = item;
      if (this.hide_hovergrp) {
        this.activatePopOver = false
      } else {
        this.activatePopOver = true
      }
      const width = $(document).width();
      const client = $event;
      if (client && (client.clientX + 420) > width) {
        this.placementPopoverInfo = 'left'
      }
    // }
  }

  onMouseleave($event, item) {
    this.activatePopOver = false;
    this.isClickVoirplus = false;
    $('.' + item.id).css('background-color', item.colors + '!important');
    $('.' + item.id).find('.active').css('background-color', item.colors + '!important');
    if (this.common.isRequestDetailArticle) {
      this.common.isRequestDetailArticle.unsubscribe();
    }
  }

  getIcons(benne) {
    if (benne.isGroupeBenne) {
      return 'groupe';
    } else {
      if (benne.typeContenant && benne.typeContenant.famille) {
        benne.typeContenant.famille.libelle = benne.typeContenant.famille.libelle || '';
        if (benne.typeContenant.famille.libelle.toLowerCase().startsWith('bac')) {
          return 'bac';
        } else {
          if (benne.typeContenant.famille.libelle.toLowerCase().startsWith('caisse') ||
            benne.typeContenant.famille.libelle.toLowerCase().startsWith('palette')) {
            return 'caissepalette';
          } else {
            if (benne.typeContenant.famille.libelle.toLowerCase().startsWith('vrac')) {
              return 'tas';
            } else {
              if (benne.typeContenant.famille.libelle.toLowerCase().startsWith('fut')) {
                return 'fut';
              } else {
                if (benne.typeContenant.famille.libelle.toLowerCase().startsWith('bigbag')) {
                  return 'bigbag';
                } else {
                  return 'benne';
                }
              }
            }
          }
        }
      } else {
        return 'benne';
      }
    }

  }

  findCouleur(benne) {
    if (benne.isGroupeBenne && !benne.isCurrent && benne.clefProgram === '0') {
      return '#ce352c'; // rouge
    } else {
      if (benne.isGroupeBenne && benne.isCurrent === 1 && benne.clefProgram === '0') {
        return '#e4e424'; // jaune
      } else {
        if (benne.isGroupeBenne && parseInt(benne.clefProgram, 10) > 0) {
          return '#8849ff'; // violet
        } else {
          if (!benne.isCurrent && benne.clefProgram === '0') {
            return '#1eafba'; // vert
          } else {
            if (benne.isCurrent === 1 && benne.clefProgram === '0') {
              return '#cbcaca'; // gris
            } else {
              if (parseInt(benne.clefProgram, 10) > 0) {
                return '#5393e0'; // bleu
              }
            }
          }
        }
      }
    }
  }

  listQteCombo() {
    let qteMax = 0;
    this.item.qteContenant = this.item.qteContenant || 1;
    qteMax = this.item.qteContenant;
    this.item.qteContenantTotaleNonUnitaire = this.item.qteContenantTotaleNonUnitaire || 1;
    if (this.item.qteContenant && this.item.qteContenantTotaleNonUnitaire) {
      qteMax = this.item.qteContenant >= this.item.qteContenantTotaleNonUnitaire ?
        this.item.qteContenant : this.item.qteContenantTotaleNonUnitaire
    }

    if (qteMax) {
      for (let i = 0; i < qteMax; i++) {
        const existe = this.listQte.filter(elt => elt.id === i + 1);
        if (!existe || (existe && !existe.length)) {
          this.listQte.push({ id: i + 1, libelleObjetEntite: '' + (i + 1) });
        }
      }
    }
  }

  setValueQte() {
    this.item.qteContenant = this.qteSelected['libelleObjetEntite'];
  }

  searchTypecontenantByLibelle(event) {
    const listContenant = this.common.getType('listetypeContenant') || [];
    this.typeContenant = []; // { id: 0, libelleObjetEntite: 'Tous' }
    if (event !== '') {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        const libelle = elt.libelleObjetEntite ? elt.libelleObjetEntite.toLowerCase() : '';
        if (libelle.includes(event.toLowerCase())) {
          this.typeContenant.push(elt);
        }
      });
    } else {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        this.typeContenant.push(elt);
      });
    }
  }

  VoirFiche($event, item) {
    this.activatePopOver = false;
    this.placementPopoverInfo = 'right';
    this.isClickVoirplus = true;
    this.infobulle = item;
    if (this.hide_hovergrp) {
      this.activatePopOver = false
    } else {
      this.activatePopOver = true
    }
    const width = $(document).width();
    const client = $event;
    if (client && (client.clientX + 300) > width) {
      this.placementPopoverInfo = 'left'
    }
  }

  public getListArticle() {
    const liste = this.item.listArticles && this.item.listArticles.length ? true : false;
    if (this.item['isGroupeArticle'] && this.item['id'] &&  this.item['id'] > 0 && this.showPopOver && !liste) {
      if (this.common.isRequestDetailArticle) {
        this.common.isRequestDetailArticle.unsubscribe();
        this.fetchData();
      } else {
        this.fetchData();
      }
    }

  }

  private fetchData() {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + this.item['id'], '1']
    };


    this.common.isRequestDetailArticle = this.common.postSub('', { param: param }).subscribe((datas)=>{
      if (datas.data) {
        this.item.listArticles = datas.data || [];
      }
      this.common.isRequestDetailArticle = null;
    },(err)=>{
      this.common.isRequestDetailArticle = null;
    });
  }
}
